import { useState, useEffect } from "react";
import {} from "../../../../api/hooks/overall";
import { observer } from "mobx-react";
import Table from "./Table";
import AnalyticsStore from "../../../../store/AnalyticsStore";
import EmptyScreen from "../../Equity/EmptyScreen/EmptyScreen";
import Dropdown from "../../Equity/Dopdown/Dropdown";
import { displayUnit } from "../../../../utils/functions";

const PortfolioAgeing = observer(
  ({
    portfolioAgeingDataCount,
    portfolioAgeingData,
    instrumentData,
    portfolioDataStatus,
    tableData,
    order,
    sortField,
    familyOptions,
    currentSortKey,
    selectedAssetClass,
    allAssetClassMenuOpen,
    setPortfolioAgeingDataCount,
    setAllAssetClassMenuOpen,
    setSelectedAssetClass,
    handleSortingChange,
    setTableData,
    setCurrentSortKey,
    setSortField,
    setOrder,
  }) => {
    // const [portfolioAgeingData, setPortfolioAgeingData] = useState([]);
    // const [allAssetClassMenuOpen, setAllAssetClassMenuOpen] = useState(false);
    // const [selectedAssetClass, setSelectedAssetClass] = useState("All");
    // const [familyOptions, setFamilyOptions] = useState([]);
    // const [tableData, setTableData] = useState([]);
    // const [order, setOrder] = useState(null);
    // const [sortField, setSortField] = useState("");
    // const [currentSortKey, setCurrentSortKey] = useState("");
    // const [instrumentData, setInstrumentData] = useState([]);
    // const [portfolioAgeingDataCount, setPortfolioAgeingDataCount] = useState(6);
    const [isTab, setIsTab] = useState(false);
    // const [portfolioDataStatus, setPortfolioDataStatus] = useState();
    // const isPrimary =
    //   (AnalyticsStore?.overall?.isPrimary ||
    //     JSON.parse(getCookie("isPrimary"))) &&
    //   UserStore.getData === "fam"
    //     ? true
    //     : false;
    // const userId =
    //   !isPrimary && (AnalyticsStore?.overall?.userId || getCookie("userid"));
    const clientWidth = document.documentElement.clientWidth;

    // const refFun = useRef();

    useEffect(() => {
      if (clientWidth < 1199) {
        setIsTab(true);
      }
    }, [clientWidth]);

    // const handleSorting = (sortField, sortOrder) => {
    //   if (tableData && sortField !== "value") {
    //     const sorted = tableData.sort((a, b) => {
    //       return (
    //         a[sortField]
    //           .toString()
    //           .localeCompare(b[sortField].toString(), "en", {
    //             numeric: true,
    //           }) * (sortOrder === "asc" ? 1 : -1)
    //       );
    //     });
    //     setTableData(sorted);
    //   } else {
    //     let sorted = tableData.sort((a, b) =>
    //       Math.abs(a.actualValue) > Math.abs(b.actualValue)
    //         ? 1
    //         : Math.abs(b.actualValue) > Math.abs(a.actualValue)
    //         ? -1
    //         : 0
    //     );
    //     if (sortOrder === "desc") {
    //       sorted.reverse();
    //     }
    //     setTableData(sorted);
    //   }
    // };

    // const handleSortingChange = (accessor) => {
    //   setCurrentSortKey(accessor);
    //   const sortOrder =
    //     accessor === sortField && order === "asc" ? "desc" : "asc";
    //   setSortField(accessor);
    //   setOrder(sortOrder);
    //   handleSorting(accessor, sortOrder);
    // };
    // useEffect(() => {
    //   let familyId = UserStore?.userData?.family_id;
    //   if (familyId) {
    //     setCookie("familyId", familyId);
    //   } else {
    //     familyId = getCookie("familyId");
    //   }
    //   setPortfolioAgeingDataCount(6);
    //   getPortfolioAgeingOptions(familyId).then((response) => {
    //     let familyOptionsObj = [];
    //     let familyOptionsId = [];

    //     response.data.map((data) => {
    //       let obj = {
    //         id: data.id,
    //         clientcode: data.clientcode,
    //         name: data.name,
    //         checked: false,
    //       };
    //       familyOptionsObj.push(obj);
    //       familyOptionsId.push(obj.id);
    //       return false;
    //     });
    //     setSelectedAssetClass([...familyOptionsId]);
    //     setFamilyOptions(familyOptionsObj);
    //     setAllAssetClassMenuOpen(true);
    //     setTimeout(() => {
    //       setAllAssetClassMenuOpen(false);
    //     }, 10);
    //   });
    // }, [userId]);

    useEffect(() => {
      let dataObj = [];
      portfolioAgeingData.map((data) => {
        let obj = {
          instrument_name: data.name,
          days_held: data.days_held,
          quantity: data.quantity,
          value: `${data.value.value} ${displayUnit(data.value.value_type)}`,
          term: data.type,
          valueType: displayUnit(data.value.value_type),
          actualValue: data.value.actual_value,
          relativeReturnPercentage: data.relative_return_percentage,
          backgroundPercentage: data.type.includes("Short Term")
            ? Math.floor((data.days_held / 365) * 100)
            : data.type.includes("Long Term")
              ? "100"
              : "",
        };
        dataObj.push(obj);
        return false;
      });

      const sorted = dataObj.sort((a, b) => {
        return (
          a["days_held"]
            .toString()
            .localeCompare(b["days_held"].toString(), "en", {
              numeric: true,
            }) * -1
        );
      });
      setTableData(sorted);
      setCurrentSortKey("days_held");
      setSortField("days_held");
      setOrder("desc");
    }, [portfolioAgeingData]);

    const getHeadingForAssetClass = (selectedAssetClass) => {
      if (
        selectedAssetClass === "All" ||
        familyOptions
          ?.map((assetClass) => selectedAssetClass?.includes(assetClass.id))
          ?.every(Boolean)
      ) {
        return "Across Categories";
      } else if (selectedAssetClass.length === 0) {
        return "None selected";
      } else {
        let assetClassHeading = "";
        const data = familyOptions
          .map((assetClass) =>
            selectedAssetClass.includes(assetClass.id) ? assetClass.name : "",
          )
          .filter((selectedAssetClass) => selectedAssetClass);
        if (data.length === 1) {
          return data[0];
        }
        data.forEach((assetClass) => {
          assetClassHeading += `${assetClass},`;
        });
        return assetClassHeading.length > 12
          ? `${assetClassHeading.slice(0, 12)}...(+${data.length - 1})`
          : assetClassHeading.length;
      }
    };

    // const assetClassFun = () => {
    //   if (!allAssetClassMenuOpen) {
    //     let familyId = UserStore?.userData?.family_id;
    //     let userId = UserStore?.userData?.user_id;
    //     if (familyId) {
    //       setCookie("familyId", familyId);
    //     } else {
    //       familyId = getCookie("familyId");
    //     }
    //     if (selectedAssetClass?.length > 0 && selectedAssetClass !== "All") {
    //       getPortfolioAgeing(familyId, userId, selectedAssetClass).then(
    //         (response) => {
    //           AnalyticsStore.setOverall({
    //             ...AnalyticsStore.overall,
    //             portfolioAgeing: response.data,
    //             portfolioAgeingLoading: false,
    //           });
    //           setPortfolioAgeingData(response.data);
    //           setInstrumentData(response);
    //           selectedAssetClass.length === familyOptions.length &&
    //             setPortfolioDataStatus(response.data?.length > 0 ? true : false);
    //           handleSorting("days_held", "desc");
    //         }
    //       );
    //     } else if (
    //       selectedAssetClass.length === 0 &&
    //       selectedAssetClass !== "All"
    //     ) {
    //       AnalyticsStore.setOverall({
    //         ...AnalyticsStore.overall,
    //         portfolioAgeing: [],
    //       });
    //       setPortfolioAgeingData([]);
    //     }
    //   }
    // };

    // refFun.current = assetClassFun;

    // useEffect(() => {
    //   refFun.current();
    // }, [allAssetClassMenuOpen]);

    const AllAssetClassMenuContent = () => {
      const handleAssetClassChange = (changedAssetClass) => {
        if (changedAssetClass === "All") {
          if (
            selectedAssetClass === "All" ||
            familyOptions
              ?.map((assetClass) => selectedAssetClass?.includes(assetClass.id))
              ?.every(Boolean)
          ) {
            setSelectedAssetClass([]);
          } else {
            setSelectedAssetClass(
              familyOptions.map((assetClass) => {
                return assetClass.id;
              }),
            );
          }
        } else {
          if (selectedAssetClass === "All") {
            setSelectedAssetClass(
              familyOptions
                .map((assetClass) => {
                  return assetClass.id;
                })
                .filter((assetClassId) => assetClassId !== changedAssetClass),
            );
          } else {
            if (selectedAssetClass.includes(changedAssetClass)) {
              setSelectedAssetClass((prevState) => {
                return prevState.filter(
                  (eachAssetClass) => eachAssetClass !== changedAssetClass,
                );
              });
            } else {
              setSelectedAssetClass([...selectedAssetClass, changedAssetClass]);
            }
          }
        }
      };
      return (
        <ul className="portfolio_report_accounts_container portfolio_ageing_dopdown_list">
          <li className="account_listitem">
            <div
              className="each_checkbox_wrapper"
              onClick={() => handleAssetClassChange("All")}
            >
              <input
                checked={
                  selectedAssetClass === "All" ||
                  familyOptions
                    ?.map((assetClass) =>
                      selectedAssetClass?.includes(assetClass.id),
                    )
                    ?.every(Boolean)
                }
                type="checkbox"
                className="checkbox"
              />
              <label className="checkbox_label portfolio_label">
                Across Categories
              </label>
            </div>
          </li>

          {familyOptions?.map((accountData) => {
            return (
              <li className="account_listitem">
                <div
                  className="each_checkbox_wrapper"
                  onClick={() => handleAssetClassChange(accountData.id)}
                >
                  <input
                    checked={
                      selectedAssetClass === "All" ||
                      selectedAssetClass.includes(accountData.id)
                        ? true
                        : false
                    }
                    type="checkbox"
                    className="checkbox"
                  />
                  <label
                    className="checkbox_label portfolio_label"
                    htmlFor={accountData.id}
                  >
                    {accountData.id === 18
                      ? accountData.name
                      : accountData.id === 55
                        ? accountData.name
                        : accountData.id === 83
                          ? accountData.name
                          : accountData.id === 52
                            ? accountData.name
                            : accountData?.name
                              ? `${accountData?.name
                                  .charAt(0)
                                  .toUpperCase()}${accountData?.name
                                  .slice(1)
                                  .toLowerCase()}`
                              : accountData?.name}
                  </label>
                </div>
              </li>
            );
          })}
        </ul>
      );
    };
    return (
      <div>
        <div className="performers asset_allocation_text">
          <div className="portfolio_ageing_head">
            <div className="portfolio_ageing_table_title">
              Portfolio <b>Ageing</b>
            </div>
            <div className="market-cap-allocation">
              <div className="equity-card-title"></div>
              {portfolioDataStatus && (
                <span className="equity-dropdown-container">
                  <span className="equity-show-me">Show me</span>
                  <div className="reports_yellow_container">
                    <div className="transecitons_yellow_wrapper">
                      <div className="transections_second_container">
                        <div className="dropdown_container portfolio_ageing_dropdown">
                          <Dropdown
                            selected={getHeadingForAssetClass(
                              selectedAssetClass,
                            )}
                            open={allAssetClassMenuOpen}
                            setOpen={setAllAssetClassMenuOpen}
                            position={{
                              top: "56px",
                              right: "1",
                              left: "-50",
                              padding: "0 0 0 0",
                            }}
                            items={AllAssetClassMenuContent}
                            handleChange={(selectedOption) => {
                              setAllAssetClassMenuOpen(false);
                            }}
                            dropdownBtnStyles={{
                              width: 210,
                              padding: isTab ? 5 : 8,
                            }}
                            menuClassName={"portfolio_ageing_menu"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </span>
              )}
            </div>
          </div>
          <div className="ageing__table">
            {portfolioAgeingData?.length > 0 ? (
              <>
                <Table
                  tableData={tableData}
                  handleSort={handleSortingChange}
                  currentSortKey={currentSortKey}
                  order={order}
                  instrumentData={instrumentData}
                  dropdownCount={portfolioAgeingDataCount}
                />
                {AnalyticsStore?.overall?.portfolioAgeing?.length >
                  portfolioAgeingDataCount && (
                  <button
                    className="show_more"
                    style={{
                      marginTop: "2%",
                      lineHeight: "20px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => {
                      setPortfolioAgeingDataCount(
                        portfolioAgeingDataCount + 20,
                      );
                    }}
                  >
                    <span className="portfolio-allocation-show-more">
                      Show More{" "}
                    </span>
                    <svg
                      width="26"
                      height="14"
                      viewBox="0 0 26 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1.59448 0.624337C2.19414 0.331437 2.91765 0.580113 3.21049 1.17981C3.67945 2.14007 4.25077 3.01986 4.90614 3.80201C4.93973 3.83717 4.97078 3.87391 4.99931 3.91185C5.95556 5.02617 7.08475 5.93593 8.33202 6.58964C8.36497 6.60269 8.39762 6.61731 8.4299 6.6335C8.46732 6.65235 8.50334 6.67277 8.53793 6.69476C9.91212 7.37699 11.4231 7.75133 13 7.75133C14.5766 7.75133 16.0877 7.37699 17.4619 6.69476C17.4966 6.67277 17.5326 6.65235 17.57 6.6335C17.6024 6.61731 17.6352 6.60269 17.6682 6.58964C18.9141 5.93653 20.0422 5.02811 20.9978 3.91548C21.028 3.875 21.0612 3.83584 21.0972 3.79851C21.7514 3.01732 22.3217 2.13886 22.79 1.18017C23.0831 0.580596 23.8066 0.331921 24.4062 0.624821C25.0058 0.917842 25.2544 1.64139 24.9614 2.24097C24.5647 3.05309 24.1019 3.82255 23.5805 4.5397L25.3335 6.29275C25.8054 6.76472 25.8054 7.52972 25.3335 8.00158C24.8616 8.47355 24.0966 8.47355 23.6246 8.00158L22 6.37697C21.2981 7.06765 20.5305 7.68028 19.7079 8.20095L20.7258 10.2305C21.025 10.827 20.7841 11.5531 20.1875 11.8523C19.591 12.1515 18.8649 11.9104 18.5657 11.314L17.5549 9.2986C16.4964 9.71753 15.3752 9.9952 14.2083 10.1093V12.5847C14.2083 13.252 13.6674 13.793 13 13.793C12.3326 13.793 11.7917 13.252 11.7917 12.5847V10.1093C10.6248 9.9952 9.50351 9.71753 8.44503 9.2986L7.43426 11.314C7.13509 11.9104 6.40898 12.1515 5.81245 11.8523C5.21593 11.5531 4.97489 10.827 5.27406 10.2305L6.29199 8.20095C5.46949 7.68016 4.70192 7.06753 4.00001 6.37685L2.37526 8.00158C1.90337 8.47355 1.1383 8.47355 0.666409 8.00158C0.19453 7.52972 0.19453 6.76472 0.666409 6.29275L2.41975 4.53946C1.89838 3.82219 1.43561 3.0526 1.03895 2.24024C0.746099 1.64067 0.994822 0.917116 1.59448 0.624337Z"
                        fill="#03002F"
                      />
                    </svg>
                  </button>
                )}
              </>
            ) : (
              <EmptyScreen
                height={400}
                loading={AnalyticsStore.overall.portfolioAgeingLoading}
              />
            )}
          </div>
        </div>
      </div>
    );
  },
);

export default PortfolioAgeing;
